<template>
  <Overlay v-on="$listeners">
    <div class="bind-dialog">
      <OrderButton class="bind-dialog_button"/>
      <Button class="bind-dialog_button" variant="outlined" type="router-link" :to="{ name: 'bind' }">
        {{ $t('Привязать карту') }}
      </Button>
    </div>
  </Overlay>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import Button from '@/common/components/Button'
import OrderButton from './OrderButton.vue'
import Overlay from '@/common/components/Overlay.vue'

@Component({
  components: { Overlay, Button, OrderButton }
})
class CardBindDialog extends Vue {
  created () {
    this.$analytics.trackCardBindDialogOpen({ screenId: this.$route.name })
  }
}

export default CardBindDialog
</script>

<style lang="scss">
.bind-dialog {
  display: flex;
  flex-direction: column;
  @include media_tablet {
    width: 416px;
  }
  @include media_desktop {
    width: 303px;
  }

  &_button {
    margin: 4px 0;
    @include media_tablet {
      margin: 6px 0;
    }
    @include media_desktop {
      margin: 13px 0;
    }
  }
}
</style>
